import React from "react";
import { Trophy } from "lucide-react";

/**
 * Verified tipster prediction score: accuracy, W/L, graded picks, and points.
 * Always reserves space so tipster slips keep a consistent score row.
 */
const CreatorRecord = ({ user, className = "", compact = false, expanded = false }) => {
  const total = Number(user?.predictionsTotal) || 0;
  const correct = Number(user?.predictionsCorrect) || 0;
  const wrong = Number(user?.predictionsWrong) || 0;
  const points = Number(user?.predictionsScores) || 0;
  const classes = [
    "pred-creator-record",
    compact ? "pred-creator-record-compact" : "",
    expanded ? "pred-creator-record-expanded" : "",
    total <= 0 ? "pred-creator-record-new" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (total <= 0) {
    return (
      <span className={classes} title="No verified prediction score yet">
        <Trophy size={compact || expanded ? 9 : 11} />
        <em>{expanded ? "No verified picks yet · 0 pts" : compact ? "New · 0 pts" : "No verified picks yet"}</em>
      </span>
    );
  }

  const accuracy = Math.round((correct / total) * 100);

  if (expanded) {
    return (
      <div
        className={classes}
        title={`${correct} correct · ${wrong} wrong · ${total} graded · ${points} pts`}
      >
        <div className="pred-creator-record-head">
          <span>
            <Trophy size={11} />
            Prediction score
          </span>
          <strong>{accuracy}%</strong>
        </div>
        <div className="pred-creator-record-track" aria-hidden>
          <i style={{ width: `${accuracy}%` }} />
        </div>
        <div className="pred-creator-record-stats">
          <span>
            <b className="pred-creator-w">{correct}</b>
            <em>Right</em>
          </span>
          <span>
            <b className="pred-creator-l">{wrong}</b>
            <em>Wrong</em>
          </span>
          <span>
            <b>{total}</b>
            <em>Graded</em>
          </span>
          <span>
            <b className="pred-creator-pts">{points}</b>
            <em>Points</em>
          </span>
        </div>
      </div>
    );
  }

  return (
    <span
      className={classes}
      title={`${correct} correct · ${wrong} wrong · ${total} graded · ${points} pts`}
    >
      <Trophy size={compact ? 9 : 11} />
      <strong>{accuracy}%</strong>
      <em>
        {correct}W · {wrong}L · {points} pts
        {compact ? "" : ` (${total} picks)`}
      </em>
    </span>
  );
};

export default CreatorRecord;
